import '@angular/localize/init';
export * from './lib/feature-tax-bezwaar-details.module';

export * from './lib/tax-bezwaar-details/feature-tax-bezwaar-details.component';
